export const RESERVE_TEST_SHARE = 0.15;
const incomeLeaving = (expenses, share) => expenses / (1 - share);
export function solveBudgetYear(inputs, settings) {
    const { expenses, otherIncome, currentSetCharges, typedCharges } = inputs;
    const fixedIncome = otherIncome + typedCharges;
    const { setCharges, reserve } = (() => {
        switch (settings.approach) {
            case 'percent_of_income': {
                const charges = (expenses - otherIncome) / (1 - RESERVE_TEST_SHARE);
                return {
                    setCharges: charges - typedCharges,
                    reserve: charges * RESERVE_TEST_SHARE,
                };
            }
            case 'reserve_study':
                return {
                    setCharges: expenses + settings.studyAmount - fixedIncome,
                    reserve: settings.studyAmount,
                };
            case 'charge_increase': {
                const setCharges = currentSetCharges * (1 + settings.percent / 100);
                return {
                    setCharges,
                    reserve: inputs.kind === 'association' ? setCharges + fixedIncome - expenses : 0,
                };
            }
            case 'cover_expenses':
                return { setCharges: expenses - fixedIncome, reserve: 0 };
            case 'target_margin':
                return {
                    setCharges: incomeLeaving(expenses, settings.percent / 100) - fixedIncome,
                    reserve: 0,
                };
            default: {
                const _exhaustive = settings;
                throw new Error(`Unhandled reserve approach: ${JSON.stringify(_exhaustive)}`);
            }
        }
    })();
    const charges = setCharges + typedCharges;
    const operatingIncome = charges + otherIncome;
    const netIncome = operatingIncome - expenses;
    const shareOf = (amount) => (operatingIncome === 0 ? 0 : amount / operatingIncome);
    const reserveShare = charges <= 0 ? 0 : reserve / charges;
    return {
        charges,
        setCharges,
        operatingIncome,
        netIncome,
        chargeChange: inputs.currentCharges === 0 ? 0 : (charges - inputs.currentCharges) / inputs.currentCharges,
        perUnitMonthly: inputs.units > 0 ? charges / inputs.units / 12 : undefined,
        outcome: inputs.kind === 'association'
            ? {
                kind: 'association',
                reserve,
                reserveShare,
                meetsReserveTest: reserveShare >= RESERVE_TEST_SHARE - 1e-9,
                balanced: Math.abs(netIncome - reserve) < 0.005,
            }
            : { kind: 'rental', netMargin: shareOf(netIncome) },
    };
}
export function reserveOf(result) {
    return result.outcome.kind === 'association' ? result.outcome.reserve : 0;
}
//# sourceMappingURL=reserve.js.map